import { Routes } from '@angular/router';
import { EventsGuard, NewsGuard } from '../content/guards';
import { BlogsGuard } from '../blogs/guards/blogs.guard';

import { HomeMetaGuard } from './guards';
import { DiseaseProfilesEmptyGuard } from '../disease-profiles/guards/disease-profiles-empty.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./containers/home/home.component').then(m => m.HomeComponent),
    pathMatch: 'full',
    canActivate: [NewsGuard, EventsGuard, BlogsGuard, HomeMetaGuard],
    canDeactivate: [DiseaseProfilesEmptyGuard],
  },
];
